//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import KlarnaExpress from '@/scripts/libs/wcs/klarna-express'
import {
  CART_KLARNA_EXPRESS_CHECKOUT,
  KLARNA_EXPRESS_CHECKOUT,
  TRACKER_CLICK,
  TRACKER_HIDDEN_ACTION,
} from '@/scripts/constants/tracker'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-klarna-express',
  computed: {
    ...mapGetters(['klarnaIsInitialized']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  async mounted() {
    await this.$nextTick()
    KlarnaExpress.initKlarnaExpress({
      vuexStore: this.$store,
      trackAnalyticsClick: this.trackAnalyticsClick,
      isMobile: this.isMobile,
    })
  },
  methods: {
    trackAnalyticsClick() {
      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_CLICK,
        value: {
          data_element_id: CART_KLARNA_EXPRESS_CHECKOUT,
          data_description: KLARNA_EXPRESS_CHECKOUT,
        },
      })
    },
  },
}
